import React from "react";
import MasterdataIndexlinks from "./indexLinks";
import axios from "axios";
import Select from "react-select";
import FormErrorHandler from "../../components/FormErrorHandler";
import MeasurementsFormPremise from "./MeasurementsFormPremise";
import { scrollToElem } from "../../functions.js";
import debounce from "debounce-promise";

export default class masterdataMeasurementsForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: props.params.itemID !== undefined,
            errorMessage: {},
            name: "",
            description: "",
            premises: [],
            measurement_type: "practice",
            bundle: "",
            competences: [],
            score_good: "",
            score_sufficient: "",
            score_to_be_improved: "",
            score_insufficient: "",
            score_exam_achieved: 0,
            score_exam_not_achieved: 0,
            order: 1,
            is_active: "0",
            dataCompetences: []
        };
    }

    updateElementState = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    addPremise = (e) => {
        e.preventDefault();
        const apiCall = axios.create();

        let postData = {
            measurement: this.props.params.itemID,
            premise: "Antwoord " + (this.state.premises.length + 1),
            score: 0,
            order: this.state.order,
            bundle: this.state.bundle,
            order: this.state.premises.length + 1,
            is_active: this.state.is_active
        };

        apiCall
            .post("/v1/measurementpremises/", postData)
            .then((response) => {
                let premises = this.state.premises.slice();
                premises.push(response.data.uuid);
                this.setState({
                    premises
                });
            })
            .catch((error) => {
                console.log(error);
                if (response.data && response.data.message) {
                    this.setState({
                        errorMessage: error.response.data
                    });
                }
                scrollToElem(document.querySelector(".form-error"));
            });
    };

    deletePremise = (id) => {
        if (confirm("Weet je zeker dat je dit antwoord wilt verwijderen?")) {
            // Delete this premise from the measurement
            const apiCall = axios.create();
            apiCall
                .delete("/v1/measurementpremises/" + id + "/")
                .then((response) => {
                    this.setState({
                        premises: this.state.premises.filter((premise) => premise != id)
                    });
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    scrollToElem(document.querySelector(".form-error"));
                });
        }
    };

    loadOptions = (url = "") => {
        return axios.get(url).then((response) => {
            return {
                options: response.data.map((item) => {
                    return {
                        value: item.uuid || item.id,
                        label: item.name
                    };
                })
            };
        });
    };

    loadCompetencesDebounced = debounce(this.loadOptions, 500);
    loadBundleDebounced = debounce(this.loadOptions, 500);

    handleOptionsChange = (val, stateName) => {
        if (Array.isArray(val)) {
            this.setState({
                [stateName]: val.map((option) => {
                    return option.value;
                })
            });
        } else if (val == null) {
            this.setState({
                [stateName]: val
            });
        } else {
            this.setState({
                [stateName]: val.value
            });
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();

        const apiCall = axios.create();
        let postData = {
            name: this.state.name,
            description: this.state.description,
            measurement_type: this.state.measurement_type,
            bundle: this.state.bundle,
            order: this.state.order,
            competences: this.state.competences,
            is_active: this.state.is_active
        };

        if (this.state.measurement_type === "practice") {
            postData = {
                ...postData,
                score_good: this.state.score_good,
                score_sufficient: this.state.score_sufficient,
                score_to_be_improved: this.state.score_to_be_improved,
                score_insufficient: this.state.score_insufficient
            };
        }
        if (this.state.measurement_type === "knowledge-exam") {
            postData = {
                ...postData,
                score_exam_achieved: this.state.score_exam_achieved,
                score_exam_not_achieved: this.state.score_exam_not_achieved
            };
        }
        if (this.state.measurement_type === "elearning") {
            postData = {
                ...postData,
                score_exam_achieved: this.state.score_exam_achieved,
                score_exam_not_achieved: this.state.score_exam_not_achieved
            };
        }

        if (this.state.editMode) {
            apiCall
                .patch("/v1/measurements/" + this.props.params.itemID + "/", postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De  '${this.state.name}' is succesvol opgeslagen`,
                        link: `/masterdata/measurements/edit/${this.props.params.itemID}`
                    });
                    this.props.router.push("/masterdata/measurements");
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    scrollToElem(document.querySelector(".form-error"));
                });
        } else {
            apiCall
                .post("/v1/measurements/", postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De  '${this.state.name}' is succesvol opgeslagen`,
                        link: `/masterdata/measurements/edit/${response.data.uuid}`
                    });

                    if (this.state.measurement_type === "knowledge") {
                        this.setState({
                            editMode: true
                        });
                        this.props.router.push("/masterdata/measurements/edit/" + response.data.uuid);
                    } else {
                        this.props.router.push("/masterdata/measurements");
                    }
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    scrollToElem(document.querySelector(".form-error"));
                });
        }
    };

    componentDidMount() {
        if (this.state.editMode) {
            const apiCall = axios.create();

            apiCall.get("/v1/measurements/" + this.props.params.itemID + "/").then((response) => {
                this.setState({
                    name: response.data.name,
                    description: response.data.description,
                    premises: response.data.premises,
                    measurement_type: response.data.measurement_type,
                    bundle: response.data.bundle ? response.data.bundle.uuid : null,
                    competences: response.data.competences,
                    score_good: response.data.score_good,
                    score_sufficient: response.data.score_sufficient,
                    score_to_be_improved: response.data.score_to_be_improved,
                    score_insufficient: response.data.score_insufficient,
                    score_exam_achieved: response.data.score_exam_achieved,
                    score_exam_not_achieved: response.data.score_exam_not_achieved,
                    order: response.data.order,
                    is_active: response.data.is_active ? 1 : 0
                });
            });
        }
    }

    render() {
        // The possible answers are dependant on the type of measurement (practice or knowledge)
        let answerRows = (
            <div className="row">
                <div className="col-3">
                    <div className="form-group">
                        <label>
                            Aantal punten bij <br />
                            'Onvoldoende' *
                        </label>
                        <input
                            type="number"
                            name="score_insufficient"
                            ref="score_insufficient"
                            onChange={this.updateElementState}
                            className="form-control form-control-md"
                            required={true}
                            value={this.state.score_insufficient}
                        />
                        <FormErrorHandler fieldName="score_insufficient" errorObject={this.state.errorMessage} />
                    </div>
                </div>
                <div className="col-3">
                    <div className="form-group">
                        <label>
                            Aantal punten bij <br />
                            'Voor verbetering vatbaar' *
                        </label>
                        <input
                            type="number"
                            name="score_to_be_improved"
                            ref="score_to_be_improved"
                            onChange={this.updateElementState}
                            className="form-control form-control-md"
                            required={true}
                            value={this.state.score_to_be_improved}
                        />
                        <FormErrorHandler fieldName="score_to_be_improved" errorObject={this.state.errorMessage} />
                    </div>
                </div>
                <div className="col-3">
                    <div className="form-group">
                        <label>
                            Aantal punten bij <br />
                            'Voldoende' *
                        </label>
                        <input
                            type="number"
                            name="score_sufficient"
                            ref="score_sufficient"
                            onChange={this.updateElementState}
                            className="form-control form-control-md"
                            required={true}
                            value={this.state.score_sufficient}
                        />
                        <FormErrorHandler fieldName="score_sufficient" errorObject={this.state.errorMessage} />
                    </div>
                </div>
                <div className="col-3">
                    <div className="form-group">
                        <label>
                            Aantal punten bij <br />
                            'Goed' *
                        </label>
                        <input
                            type="number"
                            name="score_good"
                            ref="score_good"
                            onChange={this.updateElementState}
                            className="form-control form-control-md"
                            required={true}
                            value={this.state.score_good}
                        />
                        <FormErrorHandler fieldName="score_good" errorObject={this.state.errorMessage} />
                    </div>
                </div>
            </div>
        );

        if (this.state.measurement_type === "knowledge-exam") {
            answerRows = (
                <div className="row">
                    <div className="col-3">
                        <div className="form-group">
                            <label>
                                Aantal punten bij
                                <br />
                                behaald *
                            </label>
                            <input
                                type="number"
                                name="score_exam_achieved"
                                ref="score_exam_achieved"
                                onChange={this.updateElementState}
                                className="form-control form-control-md"
                                required={true}
                                value={this.state.score_exam_achieved}
                            />
                            <FormErrorHandler fieldName="score_exam_achieved" errorObject={this.state.errorMessage} />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>
                                Aantal punten bij
                                <br />
                                niet behaald *
                            </label>
                            <input
                                type="number"
                                name="score_exam_not_achieved"
                                ref="score_exam_not_achieved"
                                onChange={this.updateElementState}
                                className="form-control form-control-md"
                                required={true}
                                value={this.state.score_exam_not_achieved}
                            />
                            <FormErrorHandler fieldName="score_exam_not_achieved" errorObject={this.state.errorMessage} />
                        </div>
                    </div>
                </div>
            );
        } else if (this.state.measurement_type === "elearning") {
            answerRows = (
                <div className="row">
                    <div className="col-3">
                        <div className="form-group">
                            <label>
                                Aantal punten bij
                                <br />
                                behaald *
                            </label>
                            <input
                                type="number"
                                name="score_exam_achieved"
                                ref="score_exam_achieved"
                                onChange={this.updateElementState}
                                className="form-control form-control-md"
                                required={true}
                                value={this.state.score_exam_achieved}
                            />
                            <FormErrorHandler fieldName="score_exam_achieved" errorObject={this.state.errorMessage} />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>
                                Aantal punten bij
                                <br />
                                niet behaald *
                            </label>
                            <input
                                type="number"
                                name="score_exam_not_achieved"
                                ref="score_exam_not_achieved"
                                onChange={this.updateElementState}
                                className="form-control form-control-md"
                                required={true}
                                value={this.state.score_exam_not_achieved}
                            />
                            <FormErrorHandler fieldName="score_exam_not_achieved" errorObject={this.state.errorMessage} />
                        </div>
                    </div>
                </div>
            );
        }

        if (this.state.measurement_type === "knowledge" && !this.state.editMode) {
            // If this is a new item it needs to be saved first before we can couple premises
            answerRows = (
                <div>
                    <h2>Antwoorden op de kennis</h2>
                    <p>Om antwoorden toe te voegen dien je deze eerst op te slaan.</p>
                </div>
            );
        }
        if (this.state.measurement_type === "knowledge" && this.state.editMode) {
            // In case of editing we can add premises
            let premiseRows = [];
            this.state.premises.forEach((premise) => {
                premiseRows.push(
                    <MeasurementsFormPremise uuid={premise} key={premise} deletePremise={(uuid) => this.deletePremise(uuid)} measurement={this.props.params.itemID} />
                );
            });

            answerRows = (
                <div>
                    <h2>Antwoorden op de kennis</h2>

                    {premiseRows}

                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                <button
                                    className="btn btn-secondary"
                                    onClick={(e) => {
                                        this.addPremise(e);
                                    }}
                                    tabIndex="0"
                                >
                                    Antwoord toevoegen
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <MasterdataIndexlinks />

                <div>
                    <form onSubmit={this.handleSubmit} ref="formref">
                        <div className="container">
                            <h2>Toetsing {this.state.editMode ? "bewerken" : "toevoegen"}</h2>

                            <div className="row">
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Titel *</label>
                                        <textarea
                                            autoFocus={true}
                                            name="name"
                                            ref="name"
                                            onChange={this.updateElementState}
                                            className="form-control"
                                            required={true}
                                            value={this.state.name == null ? "" : this.state.name}
                                        ></textarea>
                                        <FormErrorHandler fieldName="name" errorObject={this.state.errorMessage} />
                                    </div>

                                    <div className="form-group">
                                        <label>Omschrijving *</label>
                                        <textarea
                                            name="description"
                                            ref="description"
                                            onChange={this.updateElementState}
                                            className="form-control"
                                            required={true}
                                            value={this.state.description == null ? "" : this.state.description}
                                        ></textarea>
                                        <FormErrorHandler fieldName="description" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Toetsing type *</label>
                                        <select
                                            className="form-control form-control-md"
                                            name="measurement_type"
                                            ref="measurement_type"
                                            onChange={this.updateElementState}
                                            value={this.state.measurement_type}
                                            disabled={this.state.editMode}
                                        >
                                            <option value="practice">Praktijk</option>
                                            {this.state.editMode && this.state.measurement_type == "knowledge" ? <option value="knowledge">Kennis</option> : false}
                                            <option value="knowledge-exam">Theorietoets</option>
                                            <option value="elearning">E-learning</option>
                                        </select>
                                        <FormErrorHandler fieldName="measurement_type" errorObject={this.state.errorMessage} />
                                    </div>

                                    <div className="form-group">
                                        <label>Toetsbundel</label>
                                        <Select.Async
                                            {...window.selectDefaults}
                                            key="bundle"
                                            name="bundle"
                                            value={this.state.bundle}
                                            loadOptions={() => this.loadBundleDebounced("/v1/measurementbundles/?fields=uuid,name&pagination=false")}
                                            onChange={(val) => this.handleOptionsChange(val, "bundle")}
                                            closeOnSelect={true}
                                            multi={false}
                                        />
                                        <FormErrorHandler fieldName="bundle" errorObject={this.state.errorMessage} />
                                    </div>

                                    <div className="form-group">
                                        <label>Competentie(s)</label>
                                        <Select.Async
                                            {...window.selectDefaults}
                                            key="competences"
                                            name="competences"
                                            value={this.state.competences}
                                            loadOptions={() => this.loadCompetencesDebounced("/v1/competences/?fields=uuid,name&pagination=false")}
                                            onChange={(val) => this.handleOptionsChange(val, "competences")}
                                            multi={true}
                                        />
                                        <FormErrorHandler fieldName="competences" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                            </div>

                            {answerRows}

                            <div className="row">
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>Actief</label>
                                        <select
                                            className="form-control form-control-md"
                                            name="is_active"
                                            ref="is_active"
                                            onChange={this.updateElementState}
                                            value={this.state.is_active}
                                        >
                                            <option value="1">Ja</option>
                                            <option value="0">Nee</option>
                                        </select>
                                        <FormErrorHandler fieldName="is_active" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>Volgorde *</label>
                                        <input
                                            type="number"
                                            name="order"
                                            ref="order"
                                            onChange={this.updateElementState}
                                            className="form-control form-control-md"
                                            required={true}
                                            value={this.state.order}
                                        />
                                        <FormErrorHandler fieldName="order" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                            </div>

                            <FormErrorHandler fieldName="non_field_errors" errorObject={this.state.errorMessage} />

                            <div className="form-group">
                                <button className="btn btn-primary" type="submit">
                                    Opslaan
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
